// @flow

import { css } from 'styled-components';
import type { TaggedTemplateLiteral } from 'styled-components';

const valueMap = (
  allowableValues: Array<string>,
  propOfStyledComponent: string
): ({
  [name: string]: (args: any) => TaggedTemplateLiteral<>,
}) => {
  return allowableValues.reduce((acc, label) => {
    acc[label] = (...args) => css`
      ${props => props[propOfStyledComponent] === label && css(...args)};
    `;
    return acc;
  }, {});
};

export default valueMap;
